import axios from "@/plugins/axios.js"
import api from "@/api.js"
export default new class ListDetails{
	constructor(){
		this.listDetails = [];
	}
	getListDetails(){
		return this.listDetails;
	}
	async getList(pg=1){
		try{
			if (api) {				
				const uri = `${api.url}/api/v1/list/?page=${pg}`;					
				const data = await axios.get(uri);							
				return data;
			}
		}catch(er){
			console.warn("Error get TechnicalService ", er)
			return er;
		}
		return null;
	}
	async getListFor(pg=1){		
		try{
			let isLoadingReq = true;
			while(isLoadingReq){
				const res =  await this.getList(pg);
				if (res && res.data && res.data.rows.length > 0) {						
					this.listDetails 		= this.listDetails.concat(res.data.rows);// temp_list;					
				}		
				if (parseInt(res.data.pages) > pg) {
					pg++;					
				}else{
					isLoadingReq = false;
					return this.listDetails;
				}
			}			
		}catch(er){
			console.warn("Error get ListDetailsService ", er)
			return er;
		}
		
	}
}